import { BACSInstructionType } from "./bacs";

export enum Permissions {
    BASE = "base",
    MANDATE = "mandate",
    DIRECT_DEBIT = "direct_debit",
    SUPPLIER = "supplier",
    PAYROLL = "payroll",
    ORG_ADMIN = "org_admin",
    ESENDA_ADMIN = "esenda_admin",
    BACS_REPORTS = "bacs_reports",
    RECONCILIATION = "reconciliation",
}

export enum PermissionAction {
    VIEW = "view",
    EDIT = "edit",
    SUBMIT = "submit",
    APPROVE = "approve",
}

export enum OrganisationProducts {
    BACS = "bacs",
    WCBS = "wcbs",
    SOKIN_COMPLIANCE = "sokin_compliance",
    ADYEN_ONBOARDING = "adyen_onboarding",
    CARD_STATEMENTS = "card_statements",
    CONTRACTS = "contracts",
}

export const mapInstructionPermissions = new Map<
    BACSInstructionType,
    Permissions
>([
    [BACSInstructionType.MANDATE, Permissions.MANDATE],
    [BACSInstructionType.DIRECT_DEBIT, Permissions.DIRECT_DEBIT],
    [BACSInstructionType.DIRECT_CREDIT_PAYROLL, Permissions.PAYROLL],
    [BACSInstructionType.DIRECT_CREDIT_SUPPLIER, Permissions.SUPPLIER],
]);

export const ALL_BACS_PERMISSIONS_ACTIONS = [
    PermissionAction.VIEW,
    PermissionAction.EDIT,
    PermissionAction.APPROVE,
    PermissionAction.SUBMIT,
];
export const ALL_STANDARD_PERMISSIONS_ACTIONS = [
    PermissionAction.VIEW,
    PermissionAction.EDIT,
];

export const PERMISSION_GROUPS = [
    {
        key: Permissions.MANDATE,
        label: "Mandates",
        actions: ALL_BACS_PERMISSIONS_ACTIONS,
    },
    {
        key: Permissions.DIRECT_DEBIT,
        label: "Direct Debit",
        actions: ALL_BACS_PERMISSIONS_ACTIONS,
    },
    {
        key: Permissions.PAYROLL,
        label: "Payroll",
        actions: ALL_BACS_PERMISSIONS_ACTIONS,
    },
    {
        key: Permissions.SUPPLIER,
        label: "Supplier",
        actions: ALL_BACS_PERMISSIONS_ACTIONS,
    },
    {
        key: Permissions.BACS_REPORTS,
        label: "BACS Reports",
        actions: ALL_STANDARD_PERMISSIONS_ACTIONS,
    },
    {
        key: Permissions.RECONCILIATION,
        label: "Reconciliation",
        actions: ALL_STANDARD_PERMISSIONS_ACTIONS,
    },
    // add more if needed
];
